import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import Parse from 'parse'
import moment from 'moment'
import Snotify from 'vue-snotify';
import VueSwal from 'vue-swal'
import VueCurrencyFilter from 'vue-currency-filter'
import VueMeta from 'vue-meta'
import Hotjar from 'vue-hotjar'
import './registerServiceWorker'
import i18n from './i18n'

Vue.config.productionTip = false

// .env file contains those definitions.

Parse.initialize(process.env.VUE_APP_PARSE_SERVER_APPLICATION_ID, process.env.VUE_APP_JS_KEY)
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL

moment.locale('es');
Vue.use(require('vue-moment'), {
  moment
})

Vue.use(Snotify, {
  toast: {
    timeout: 4000
  },
  global: {
    preventDuplicates: true
  }
})

Vue.use(VueSwal)

Vue.use(VueCurrencyFilter, {
  symbol : '$',
  thousandsSeparator: ',',
  fractionCount: 0,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

Vue.use(VueMeta)

Vue.use(Hotjar, {
  id: '1915972', // Hotjar Site ID
  isProduction: true
})

Vue.filter('str_limit', function (value, size) {
  if (!value) return '';
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + '...';
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
